import { createIcon } from './factory'
import Icon from './money-wavy.svg?react'

export const MoneyWavy = createIcon({ regular: Icon, bold: Icon, fill: Icon, duotone: Icon })
